import {
  createSlice,
  createAsyncThunk,
  createSelector } from
'@reduxjs/toolkit';
import { ApolloClient, gql, NormalizedCacheObject } from '@apollo/client';
import { RootState } from '@src/redux/store';
import * as TYPES from '@src/redux/types';

const GRAPHQL = gql`
  mutation unarchiveSubject($id: String!) {
    unarchiveSubject(id: $id) {
      id
      status
      error {
        message
        statusCode
      }
    }
  }
`;

const initialState: TYPES.MutationResponseState = {
  result: null,
  error: null,
  loading: false
};

export const unarchiveSubjectRequest = createAsyncThunk<
  TYPES.MutationResponse,
  {id: String;},
  {extra: ApolloClient<NormalizedCacheObject>;}>(

  'subject/unarchive_subject',
  async (params: {id: String;}, { extra: client }) => {
    try {
      const response = await client.mutate({
        mutation: GRAPHQL,
        variables: params
      });
      return response.data.unarchiveSubject;
    } catch (error) {
      const err = error as {message?: String;statusCode?: String;};
      return Promise.reject({
        message: err.message || 'An error occurred',
        statusCode: err.statusCode || '500'
      });
    }
  }
);

const unarchiveSubjectSlice = createSlice({
  name: 'unarchive_subject',
  initialState: initialState,
  reducers: {
    unarchiveSubjectClear: (state) => {
      state.result = null;
      state.error = null;
      state.loading = false;
    }
  },
  extraReducers: (builder) => {
    builder.
    addCase(unarchiveSubjectRequest.pending, (state) => {
      state.result = null;
      state.error = null;
      state.loading = true;
    }).
    addCase(unarchiveSubjectRequest.fulfilled, (state, action) => {
      state.result = action.payload;
      state.loading = false;
    }).
    addCase(unarchiveSubjectRequest.rejected, (state, action) => {
      state.error = action.payload as Error || {
        message: 'Failed to fetch',
        statusCode: '500'
      };
      state.loading = false;
    });
  }
});

export const { unarchiveSubjectClear } = unarchiveSubjectSlice.actions;

export const unarchiveSubject = createSelector(
  (state: RootState) => state.subject.unarchiveSubject.result,
  (state: RootState) => state.subject.unarchiveSubject.error,
  (state: RootState) => state.subject.unarchiveSubject.loading,
  (result, error, loading) => ({
    result,
    error,
    loading
  })
);

export default unarchiveSubjectSlice.reducer;